export class Coverage {
  completed = false;
  questionCoverages = [];
  questionRiskProfiles=[]
}



// WEBPACK FOOTER //
// ./src/app/core/models/coverage.ts